import { Component, OnInit } from '@angular/core';
import { ProgressService } from '../../../@theme/services/progress.service';
import { ChangeDetectorRef, inject } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progressBar.component.html',
  styleUrls: ['./progressBar.component.css'],
  standalone: true,
  imports: [CommonModule] // Agregar CommonModule aquí
})
export class ProgressBarComponent implements OnInit {
  message: string = '';
  icon: string = 'info';
  progress: number = 0;
  isVisible: boolean = false;
  cantidadFacturas: number = 0;
  private cdr = inject(ChangeDetectorRef);

  constructor(private progressService: ProgressService) {}

  ngOnInit() {
    // Se suscribe al observable para recibir actualizaciones
    this.progressService.toastObservable.subscribe((toast) => {
      this.isVisible = toast.isVisible;
      this.message = toast.message;
      this.icon = toast.icon;
      this.progress = toast.progress;
      this.cantidadFacturas = toast.cantidadFacturas;
      console.log('sadasdasds', toast);
    });
  }
}
